
  import { Vue, Component, Prop } from "vue-property-decorator";
  import RadioOption from "@/entities/RadioOption";

  @Component
  export default class RadioButtonGroup extends Vue {
    @Prop({ default: "all", type: String }) value!: string;
    @Prop({ required: true, type: Array }) options!: RadioOption[];
    @Prop({ default: "radioChoice", type: String }) name!: string;
    @Prop({ type: Boolean, default: false }) blue!: boolean;
    @Prop({ type: String, default: '' }) readonly parentClass!: string;
    @Prop({ type: String, default: '' }) readonly bgCheckColor!: string;
    @Prop({ type: String, default: '' }) readonly labelClass!: string;


    get getParentClasses(){
      return {
        'bg-custom_bg': !!this.bgCheckColor,
        [this.parentClass]: true
      }
    }
    get getLabelClasses(){
      return {
        'blue': this.blue,
        'bg-label_custom_bg': !!this.bgCheckColor,
        [this.labelClass]: true
      }
    }
    handleChange(event: any) {
      this.$emit("input", event.target.value);
    }
  }
